import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css"; // removes uneccesary blank space
import "react-pdf/dist/esm/Page/TextLayer.css"; // removes uneccesary text

export default function AllPagesViewer(props: any) {
  const [numPages, setNumPages] = useState(1);

  function onDocumentLoadSuccess(pdfObject: any) {
    setNumPages(pdfObject.numPages ?? 1);
  }

  const { pdf } = props;

  pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

  return (
    <Document file={pdf} options={{}} onLoadSuccess={onDocumentLoadSuccess}>
      {Array.from(new Array(numPages), (el, index) => (
        <Page key={`page_${index + 1}`} pageNumber={index + 1} />
      ))}
    </Document>
  );
}
